import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import PhoneNotificationPreviewWithImage from 'components/NotificationsPreview/PhoneNotificationPreviewWithImage';

const styles = {
	previewDeviceContainer: {
		justifyContent: 'center',
		backgroundColor: '#F5F5F5',
		width: 'calc(100% + 40px)',
		margin: '30px -20px -15px',
		paddingBottom: '15px',
	},
	previewImage: {
		position: 'relative',
		flexBasis: 'unset',
		margin: '10px 20px 20px',
		minWidth: '330px',
		width: '330px',
	},
}

class MarketingCreateBroadcastPreview extends Component {
	render() {
		const { classes } = this.props;
		const notificationTitle = 'Dear Customer,'

		return (
			<GridContainer className={classes.previewDeviceContainer}>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImage}>
					<PhoneNotificationPreviewWithImage
						type='ios'
						notificationTitle={notificationTitle}
						text={this.props.text}
						image={this.props.image}
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImage}>
					<PhoneNotificationPreviewWithImage
						type='android'
						notificationTitle={notificationTitle}
						text={this.props.text}
						image={this.props.image}
					/>
				</GridItem>
			</GridContainer>
		);
	}
}

MarketingCreateBroadcastPreview.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string,
	image: PropTypes.string,
};

export default withStyles(styles)(MarketingCreateBroadcastPreview);
